import React, { useState, useEffect } from 'react';
import './StaticPage.css';

export default function Unsubscribe() {
  const [status, setStatus] = useState('idle'); // idle | loading | success | error | already
  const [email, setEmail] = useState('');
  const [inputEmail, setInputEmail] = useState('');

  useEffect(() => {
    // Pre-fill from URL param
    const params = new URLSearchParams(window.location.search);
    const e = params.get('e') || params.get('email') || '';
    if (e) { setEmail(e); setInputEmail(e); }
  }, []);

  const handleUnsub = async () => {
    const target = inputEmail.trim();
    if (!target.includes('@')) return;
    setStatus('loading');
    try {
      const res = await fetch('/api/unsubscribe.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: target }),
      });
      const data = await res.json();
      if (data.already) setStatus('already');
      else if (data.success) setStatus('success');
      else setStatus('error');
    } catch {
      setStatus('error');
    }
  };

  return (
    <div className="static-page">
      <nav className="static-nav">
        <a href="/" className="logo-text">
          <span style={{color:'#0D9488'}}>ICH</span>TYP<span className="logo-de">.DE</span>
        </a>
      </nav>

      <main className="static-main">
        <div className="static-card unsub-card">

          {status === 'idle' && (
            <>
              <div className="unsub-icon">📭</div>
              <h1 className="static-title">Abmeldung vom Newsletter</h1>
              <p className="static-sub">
                Schade, dass du gehst. Du kannst dich hier von allen E-Mails von ICHTYP.DE abmelden.
                Nach der Abmeldung erhältst du keine weiteren E-Mails von uns.
              </p>

              <div className="unsub-form">
                <input
                  type="email"
                  className="static-input"
                  placeholder="Deine E-Mail-Adresse"
                  value={inputEmail}
                  onChange={e => setInputEmail(e.target.value)}
                  onKeyDown={e => e.key === 'Enter' && handleUnsub()}
                />
                <button className="btn-unsub" onClick={handleUnsub}>
                  Jetzt abmelden
                </button>
              </div>

              <p className="unsub-note">
                Du kannst ICHTYP.DE jederzeit wieder besuchen und den Test erneut machen.
                Eine erneute Anmeldung ist jederzeit möglich.
              </p>
            </>
          )}

          {status === 'loading' && (
            <>
              <div className="unsub-icon">⏳</div>
              <h1 className="static-title">Wird bearbeitet...</h1>
              <div className="loading-dots" style={{justifyContent:'center',marginTop:16}}>
                <span style={{width:10,height:10,background:'var(--teal)',borderRadius:'50%',display:'inline-block',animation:'blink 1.2s infinite'}}/>
                <span style={{width:10,height:10,background:'var(--teal)',borderRadius:'50%',display:'inline-block',animation:'blink 1.2s 0.2s infinite'}}/>
                <span style={{width:10,height:10,background:'var(--teal)',borderRadius:'50%',display:'inline-block',animation:'blink 1.2s 0.4s infinite'}}/>
              </div>
            </>
          )}

          {status === 'success' && (
            <>
              <div className="unsub-icon">✅</div>
              <h1 className="static-title">Erfolgreich abgemeldet</h1>
              <p className="static-sub">
                Die E-Mail-Adresse <strong>{inputEmail}</strong> wurde erfolgreich von unserem
                Verteiler abgemeldet. Du erhältst keine weiteren E-Mails von ICHTYP.DE.
              </p>
              <a href="/" className="btn-home">← Zurück zur Startseite</a>
            </>
          )}

          {status === 'already' && (
            <>
              <div className="unsub-icon">ℹ️</div>
              <h1 className="static-title">Bereits abgemeldet</h1>
              <p className="static-sub">
                Die E-Mail-Adresse <strong>{inputEmail}</strong> ist bereits in unserer
                Abmeldeliste. Du erhältst keine E-Mails von uns.
              </p>
              <a href="/" className="btn-home">← Zurück zur Startseite</a>
            </>
          )}

          {status === 'error' && (
            <>
              <div className="unsub-icon">❌</div>
              <h1 className="static-title">Fehler aufgetreten</h1>
              <p className="static-sub">
                Es ist ein Fehler aufgetreten. Bitte versuche es erneut oder kontaktiere uns
                unter <a href="mailto:kontakt@ichtyp.de" style={{color:'var(--teal)'}}>kontakt@ichtyp.de</a>.
              </p>
              <button className="btn-home" onClick={() => setStatus('idle')}>← Erneut versuchen</button>
            </>
          )}

        </div>
      </main>

      <footer className="static-footer">
        <p>© 2025 ICHTYP.DE · <a href="/datenschutz">Datenschutz</a> · <a href="/impressum">Impressum</a></p>
      </footer>
    </div>
  );
}
